import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent } from '../card/card.component';
import { HeadingImageComponent } from './heading-image/heading-image.component';
import { LandingGetStartedSectionComponent } from './getstarted/getstarted.component';
import { TextComponent } from './text/text.component';
import { LandingContainerComponent } from './container/container.component';
import { SharedModule } from '../../shared/shared.module';
import { MagicAiVideoSectionComponent } from './video/video.component';
import { QuotesComponent } from './quotes/quotes.component';
import { FlowDiagramComponent } from './flow-diagram/flow-diagram.component';
import { HeadingTitleComponent } from './heading-title/heading-title.component';

const COMPONENTS = [
  CardComponent,
  HeadingImageComponent,
  HeadingTitleComponent,
  TextComponent,
  LandingGetStartedSectionComponent,
  LandingContainerComponent,
  MagicAiVideoSectionComponent,
  QuotesComponent,
  FlowDiagramComponent,
];

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    SharedModule,
    RouterModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class LandingSharedModule {}
